module.exports = __webpack_public_path__ + "img/wadd-coin.30223ff1.svg";